/**
 * Ao instalar o PWA a partir da agenda da sala, o manifest não inclui query (?token=…).
 * Gravamos a query em localStorage e, ao abrir a app instalada (standalone),
 * redirecionamos para /#/agenda-sala?…
 */
const STORAGE_KEY = "thalamus_pwa_agenda_inicio_v1";

export function isModoStandalonePwa() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.matchMedia("(display-mode: fullscreen)").matches ||
    window.navigator.standalone === true
  );
}

/** Chamar quando a agenda tem `token` (ou legado `calendario`) na URL. */
export function salvarAgendaInstalacaoPwa(query) {
  try {
    const token = query?.token;
    if (token != null && String(token).trim() !== "") {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ token: String(token).trim() })
      );
      return;
    }
    const c = query?.calendario;
    if (c == null || String(c).trim() === "") return;
    const payload = {
      calendario: String(c).trim(),
    };
    if (query.nome != null && String(query.nome).trim() !== "") {
      payload.nome = String(query.nome).trim();
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (_) {
    /* ignore */
  }
}

function lerQueryAgendaSalva() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw);
    if (o?.token) {
      return { token: String(o.token) };
    }
    if (!o?.calendario) return null;
    const q = { calendario: String(o.calendario) };
    if (o.nome) q.nome = String(o.nome);
    return q;
  } catch {
    return null;
  }
}

/**
 * Se a app abriu como PWA e há agenda gravada, vai para a mesma sala.
 * @param {import('vue-router').Router} router
 */
export async function aplicarInicioPwaAgenda(router) {
  if (!isModoStandalonePwa()) return;
  const q = lerQueryAgendaSalva();
  if (!q) return;

  const r = router.currentRoute.value;
  if (r.name === "AgendaSala") {
    if (q.token && r.query?.token != null && String(r.query.token) === String(q.token)) {
      return;
    }
    if (
      q.calendario &&
      r.query?.calendario != null &&
      String(r.query.calendario) === String(q.calendario)
    ) {
      return;
    }
  }

  await router.replace({ name: "AgendaSala", query: q });
}
